import { Component, Input } from '@angular/core';
import { ModalService } from '../modal.service';
import { AbstractModal } from '../AbstractModal';

@Component({
  selector: 'ls-delete-modal',
  templateUrl: 'delete-modal.component.html'
})
export class DeleteModalComponent extends AbstractModal {
  @Input()
  public data: any;

  constructor(private modal: ModalService) {
    super();
  }

  public close(answer: boolean = false): void {
    this.modal.close(answer);
  }
}
